import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type globalLoaderState = {
	showGlobalLoader: boolean
}

export const globalLoaderInitialState: globalLoaderState = {
	showGlobalLoader: false,
}

export namespace GlobalLoaderNS {
	export type ShowGlobalLoader = PayloadAction
	export type HideGlobalLoader = PayloadAction
}
export const loadersSlice = createSlice({
	name: 'loaders',
	initialState: globalLoaderInitialState,
	reducers: {
		showGlobalLoader: (state, action: GlobalLoaderNS.ShowGlobalLoader) => {
			state.showGlobalLoader = true
		},
		hideGlobalLoader: (state, action: GlobalLoaderNS.HideGlobalLoader) => {
			state.showGlobalLoader = false
		},
	},
})
